import React from "react";
import { Box } from "@mui/material";
import { Button } from "@mui/material";

export default function AssetImageModal({ assetImage, handleClose }) {
  return (
    <Box className="asset-image-modal">
      <section className="asset-image-section">
        <h2>Asset Image</h2>
        {assetImage ? (
          <>
            <img src={assetImage && assetImage} alt="A picture of the asset" />
          </>
        ) : (
          <h2>No Image of asset</h2>
        )}
        <Button
          onClick={() => handleClose(false)}
          variant="contained"
          Í
          color="error"
        >
          Close
        </Button>
      </section>
    </Box>
  );
}
